export const CHANGE = 'locale.CHANGE'
